export const galleryRequest = async (path, token, options = {}) => {
  const headers = { ...(options.headers || {}), Authorization: `Bearer ${token}` };
  if (options.body && !(options.body instanceof FormData)) headers['Content-Type'] = 'application/json';
  const response = await fetch(`/api${path}`, { ...options, headers });
  const data = response.headers.get('content-type')?.includes('application/json')
    ? await response.json()
    : null;
  if (!response.ok) {
    const detail = data?.detail;
    const error = new Error(typeof detail === 'string' ? detail : detail?.message || 'Request failed');
    error.status = response.status;
    error.detail = detail;
    throw error;
  }
  return data;
};

export const formatChicago = (value) => value || 'Not set';